import { Button, Grid, TextField, Checkbox, FormControlLabel, DialogActions, IconButton, } from '@mui/material';
import styles from './styles.module.css';
import CloseIcon from '@mui/icons-material/Close';
import React, { useState, useContext } from 'react';
import VendorServices from 'services/VendorServices';
import { AlertMessagesContext } from 'react-alert-messages';
import NumberField from 'components/library/NumberField';
import { useTranslation } from 'react-i18next';

export default function EditCustomerDialog(props) {
  const { toggleEditTab, editData, getVendors } = props;
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');
  const [name, setName] = useState(editData.name);
  const [mobile, setMobile] = useState(editData.mobile);
  const [code, setCode] = useState(editData.code);
  const [isActive, setIsActive] = useState(editData.is_active);
  const [balance, setBalance] = useState(editData.balance);
  const [address, setAddress] = useState(editData.address);
  const [loadingIndicator, setLoadingIndicator] = useState(false);
  const { postAlertMessage } = useContext(AlertMessagesContext);

  const handleUpdateVendor = async () => {
    setLoadingIndicator(true);
    const data = {
      ...editData,
      name,
      mobile,
      code,
      is_active: isActive,
      address,
    };
    try {
      await VendorServices.updateVendor(editData.id, data);

      // Balance is a computed field from journal entries on the backend.
      // If the user changed the balance, create a journal entry for the difference.
      const newBalance = Number(balance) || 0;
      const oldBalance = Number(editData.balance) || 0;
      if (newBalance !== oldBalance) {
        const debitAmount = newBalance - oldBalance;
        await VendorServices.addPaymentToVendor(editData.id, {
          debit: debitAmount,
          payment_time: new Date().toISOString(),
        });
      }

      postAlertMessage({
        text: tPopup("Vendor updated successfully"),
        type: 'success',
      });
    } catch (err) {
      postAlertMessage({
        text: err.message,
        type: 'failed',
      });
    }
    setLoadingIndicator(false);
    toggleEditTab();
    getVendors();
  };

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{tCommon("Edit Vendor")}</h2>
          <IconButton onClick={toggleEditTab}><CloseIcon /></IconButton>
        </div>
        <div className={styles.inputSec}>
          <Grid container className={styles.inputRow} alignItems="flex-start" spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField label={tCommon("Vendor Id")} variant="outlined" size="small" fullWidth disabled value={editData.id} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label={tCommon("Vendor Name")}
                variant="outlined"
                size="small"
                fullWidth
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label={tCommon("Vendor Mobile")}
                name="Mobile"
                size="small"
                variant="outlined"
                fullWidth
                value={mobile}
                onChange={(e) => {
                  setMobile(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label={tCommon("Vendor Code")}
                name="code"
                size="small"
                variant="outlined"
                fullWidth
                value={code}
                onChange={(e) => {
                  setCode(e.target.value.toUpperCase());
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label={tCommon("Vendor Address")}
                variant="outlined"
                size="small"
                name="address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                fullWidth
                multiline
                maxRows={4}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <NumberField
                label={tCommon("Vendor Balance")}
                className={styles.numberInput}
                name="balance"
                value={balance}
                onChange={(e) => setBalance(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                value="end"
                control={
                  <Checkbox
                    color="primary"
                    checked={isActive}
                    onChange={(e) => setIsActive(e.target.checked)}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                }
                label={tCommon("Active Vendor")}
                labelPlacement="end"
              />
            </Grid>
            <Grid item xs={12} sm={6}></Grid>
          </Grid>
        </div>
        <div className={styles.footSec}>
          <DialogActions>
            <Button variant="contained" color="secondary" size="small" onClick={toggleEditTab}>
              {tCommon("Close")}
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              disabled={name === '' || mobile === '' || code === '' || loadingIndicator}
              onClick={handleUpdateVendor}
            >
              {tCommon("Update Vendor")}
            </Button>
          </DialogActions>
        </div>
      </div>
    </div>
  );
}
